import { Flex, HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import { Plus } from 'lucide-react';
import { useMemo } from 'react';
import { useBuyerOfferAnalysisContext } from '../../BuyerOfferAnalysis/Context/BuyerOfferAnalysisContext';
import { OfferScoreGauge } from '../../BuyerOfferAnalysis/OfferScore/OfferScoreGauge';

export const MOBILE_FOOTER_HEIGHT = 60;

export const MobileOfferScoreFooter = () => {
  const { isChatOpen, setIsChatOpen, isViewOnly } =
    useBuyerOfferAnalysisContext();
  const footerText = useMemo(() => {
    if (isViewOnly) {
      return 'Offer Score';
    }

    return 'Offer Score & Coach';
  }, [isViewOnly]);

  return (
    <Flex
      alignItems="center"
      bg="black"
      flexShrink={0}
      height={`${MOBILE_FOOTER_HEIGHT}px`}
      justifyContent="space-between"
      px={5}
      py={2}
      width="100%"
    >
      <HStack>
        {!isViewOnly && (
          <IconButton
            aria-label="Offer Score & Coach"
            colorScheme="gray"
            icon={
              <Icon
                as={Plus}
                height="20px"
                transform={isChatOpen ? 'rotate(45deg)' : undefined}
                transition="transform 0.3s ease"
                width="20px"
              />
            }
            size="sm"
            variant="ghost"
            onClick={() => setIsChatOpen((prev) => !prev)}
          />
        )}
        <Text color="whiteAlpha.600" fontWeight="medium" size="sm">
          {footerText}
        </Text>
      </HStack>

      <OfferScoreGauge maskColor="black" size="sm" />
    </Flex>
  );
};
